<script>
import Questions from "./Questions";
import Address from "./Steps/Address";
import ToBe from "./Steps/ToBe";
import PerSchedule from "./PerSchedule";
import PerProfessional from "./PerProfessional";
import AdditionalInformations from "./Steps/AdditionalInformations";
import Confirmation from "./Steps/Confirmation";

import scrollMixin from "@/mixins/scrollMixin";

import { mapState, mapGetters, mapActions } from "vuex";

export default {
  mixins: [scrollMixin],

  computed: {
    ...mapState("newOrder", [
      "address",
      "to_be",
      "professional",
      "day",
      "starts_at",
      "ends_at",
      "additional_informations"
    ]),
    ...mapState("user", ["user"]),
    ...mapGetters("newOrder", ["canShowConfirmation"])
  },

  components: {
    Questions,
    Address,
    ToBe,
    PerSchedule,
    PerProfessional,
    AdditionalInformations,
    Confirmation
  },

  methods: {
    ...mapActions("newOrder", ["setOrdersWithDiscount"]),
    canShowAdditionalInformations() {
      return this.professional && this.ends_at;
    }
  },

  mounted() {
    this.setOrdersWithDiscount();
  }
};
</script>

<template>
  <div class="container">
    <div class="row">
      <div class="left">
        <div class="card">
          <transition-group name="fade" mode="out-in">
            <Address
              key="address"
              :selected="address"
              :class="{'passed-on': address}"
              @scrollTo="scrollTo('#to-be')"
            />

            <ToBe
              key="to-be"
              id="to-be"
              v-if="address"
              :class="{'passed-on': to_be}"
              @scrollTo="scrollTo('#to-be-selected')"
            />

            <PerSchedule
              key="per-schedule"
              v-if="to_be === 'schedule'"
              id="to-be-selected"
              @scrollTo="scrollTo($event)"
            />

            <PerProfessional
              key="per-professional"
              v-if="to_be === 'professional'"
              id="to-be-selected"
              @scrollTo="scrollTo($event)"
            />

            <AdditionalInformations
              key="additional-informations"
              v-if="canShowAdditionalInformations()"
              id="additional-informations"
              :class="{'passed-on': additional_informations}"
              @scrollTo="scrollTo('#confirmation')"
            />

            <Confirmation
              key="confirmation"
              v-if="canShowConfirmation"
              id="confirmation"
              from="purchase-flow"
            />
          </transition-group>

          <div id="bottom"></div>
        </div>
      </div>

      <div class="right">
        <questions />
      </div>
    </div>
  </div>
</template>

<style scoped>
.section {
  transition: all 0.24s ease;
}

.section.passed-on {
  opacity: 0.35;
}

.section.passed-on:hover,
.section.passed-on:active {
  opacity: 1;
}

.left {
  width: calc(70% - 10px);
  display: flex;
  align-items: flex-start;
  align-content: flex-start;
  margin-right: 10px;
}

.right {
  width: calc(30% - 10px);
  flex: none;
  display: flex;
  flex-direction: column;
  margin-left: 10px;
  margin-right: 0;
}

.card {
  width: calc(100% - 48px);
  transition: all 0.25s ease;
}

@media (max-width: 992px) {
  .row {
    flex-direction: column !important;
  }

  .left {
    width: 100%;
    margin-right: 0;
  }

  .right {
    display: none;
  }
}

@media (max-width: 768px) {
  .right {
    flex-direction: column;
  }
  .right .card {
    margin-right: 0 !important;
    margin-left: 0 !important;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/PurchaseFlow/Index.vue